export default "__VITE_ASSET__b0cnudsA__"